import React, { useState } from "react";
import axios from "axios";
import { URL } from "./api";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    user_name: "",
    password: "",
  });

  const [, setError] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Forget Password States
  const [forgotStep, setForgotStep] = useState(1); // 1: Username, 2: OTP & New Pass
  const [forgotData, setForgotData] = useState({
    userName: "",
    otp: "",
    newPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });


  // --- FORGOT PASSWORD HANDLERS ---
  const handleForgotChange = (e) =>
    setForgotData({ ...forgotData, [e.target.name]: e.target.value });

  // Step 1: Send OTP
  const handleSendOtp = async () => {
    if (!forgotData.user_name) {
      toast.error("Please enter username");
      return;
    }
    setLoading(true);
    try {
      // API call using params as per your backend requirement
      const res = await axios.post(`${URL.FORGETPASSWORDOTP}?userName=${forgotData.user_name}`);
      toast.success(res.data.message || "OTP sent successfully");
      setForgotStep(2);
    } catch (err) {
      toast.error(err.response?.data?.error || "User not found or error sending OTP");
    } finally {
      setLoading(false);
    }
  };

  // Step 2: Reset Password
  const handleResetPassword = async () => {
    const { user_name, otp, newPassword } = forgotData;
    if (!otp || !newPassword) {
      toast.error("All fields are required");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(
        `${URL.RESTARTPASSWORD}?userName=${user_name}&otp=${otp}&newPassword=${newPassword}`
      );
      toast.success(res.data.message || "Password updated successfully");
      setShowPopup(false);
      resetForgotState();
    } catch (err) {
      toast.error(err.response?.data?.error || "Invalid OTP or Reset Failed");
    } finally {
      setLoading(false);
    }
  };

  const resetForgotState = () => {
    setForgotStep(1);
    setForgotData({ user_name: "", otp: "", newPassword: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post(URL.USER_LOGIN, form, {
        headers: { "Content-Type": "application/json" },
      });

      const msg = res?.data?.message || "Login successful";
      toast.success(msg, { position: "top-center" });

      localStorage.setItem("authToken", res.data.token);
      localStorage.setItem("privilege", res.data.privilege);
      localStorage.setItem("username", res.data.user_name);
      localStorage.setItem("userId", res.data.user_id);
      localStorage.setItem("isAdmin",res.data.is_admin);
      localStorage.setItem("companyCode",res.data.company_code);
      localStorage.setItem("branch_code",res.data.branch_code);
      navigate("/Dashboard");
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Invalid credentials";
      toast.error(msg, { position: "top-center" });
      setError(msg);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        background: "#f5f7fa",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Arial, sans-serif",
        position: "relative",
      }}
    >
      {/* Blue top strip */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "120px", // ~2 inch strip
          background:  "#024c8c",
          boxShadow: "0px 4px 8px rgba(0,0,0,0.2)", // subtle shadow
          zIndex: 1,
        }}
      ></div>

      {/* Login form */}
      <form
        onSubmit={handleSubmit}
        style={{
          backgroundColor: "#fff",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
          width: "380px",
          display: "flex",
          flexDirection: "column",
          zIndex: 2,
        }}
      >
      <h2
  style={{
    textAlign: "center",
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "30px",
    color: "#1e293b",
    letterSpacing: "0.5px",
    position: "relative",
  }}
>
  Login to LMS
  <span
    style={{
      display: "block",
      width: "60px",
      height: "4px",
      margin: "10px auto 0",
      borderRadius: "10px",
      background: "linear-gradient(90deg, #2563eb, #7c3aed)",
    }}
  ></span>
</h2>

        <input
          type="text"
          name="user_name"
          placeholder="Username"
          value={form.user_name}
          onChange={handleChange}
          required
          style={{
            padding: "14px",
            marginBottom: "18px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            fontSize: "15px",
            outline: "none",
            transition: "0.3s",
          }}
          onFocus={(e) => (e.target.style.border = "1px solid #3498db")}
          onBlur={(e) => (e.target.style.border = "1px solid #ddd")}
        />

        <div style={{ position: "relative", marginBottom: "12px" }}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={form.password}
                onChange={handleChange}
                required
                style={{
                  padding: "14px",
                  width: "100%",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  fontSize: "15px",
                  outline: "none",
                  transition: "0.3s",
                  paddingRight: "40px", // space for icon
                }}
                onFocus={(e) => (e.target.style.border = "1px solid #3498db")}
                onBlur={(e) => (e.target.style.border = "1px solid #ddd")}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  width: "20px",
                  height: "20px",
                  color: "#555",
                }}
              >
                {showPassword ? (
                  // Eye with slash (hide)
                  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 6.5c3.79 0 7.17 2.13 8.82 5.5-1.05 2.17-2.77 3.93-4.87 4.93l1.45 1.45c2.53-1.24 4.54-3.36 5.6-5.96C21.17 8.63 16.91 5.5 12 5.5c-1.5 0-2.92.31-4.2.86l1.47 1.47C10.24 7.32 11.11 7 12 7zM2.1 2.1L0.69 3.51l3.36 3.36C2.39 8.12 1.17 9.95.58 12c1.61 4.06 5.48 7 10.42 7 1.92 0 3.72-.51 5.27-1.41l3.8 3.8 1.41-1.41L2.1 2.1zM12 15c-.82 0-1.54-.32-2.07-.85l-1.49-1.49C8.18 12.19 8 12.59 8 13c0 1.1.9 2 2 2 .41 0 .81-.18 1.34-.44l1.49 1.49C13.54 14.68 12.82 15 12 15z"/>
                  </svg>
                ) : (
                  // Eye (show)
                  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 4.5C7.05 4.5 2.83 7.64 1.17 12c1.66 4.36 5.88 7.5 10.83 7.5s9.17-3.14 10.83-7.5C21.17 7.64 16.95 4.5 12 4.5zm0 12c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z"/>
                    <circle cx="12" cy="12" r="2.5"/>
                  </svg>
                )}
              </span>
              </div>
        {/* Forgot Password */}
        <span
          onClick={() => setShowPopup(true)}
          style={{
            textAlign: "right",
            marginBottom: "20px",
            fontSize: "14px",
            color: "#024c8c",
            cursor: "pointer",
          }}
        >
          Forgot Password?
        </span>

        <button
          type="submit"
          style={{
            padding: "14px",
            background: "#024c8c",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "0.3s",
          }}
          onMouseOver={(e) => (e.target.style.background =  "#024c8c")}
          onMouseOut={(e) => (e.target.style.background =  "#024c8c")}
        >
          Login
        </button>

        <ToastContainer />
      </form>

      
{/* --- UPDATED FORGOT PASSWORD POPUP --- */}
      {showPopup && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
          <div style={{ background: "#fff", padding: "30px", borderRadius: "12px", width: "350px", textAlign: "center", position: "relative" }}>
            <span 
                onClick={() => { setShowPopup(false); resetForgotState(); }} 
                style={{ position: "absolute", top: "10px", right: "15px", cursor: "pointer", fontSize: "20px" }}
            >×</span>
            
            <h3 style={{ marginBottom: "20px", color: "#024c8c" }}>Reset Password</h3>

            {forgotStep === 1 ? (
              <>
                <input
                  type="text"
                  name="user_name"
                  placeholder="Enter Username"
                  value={forgotData.user_name}
                  onChange={handleForgotChange}
                  style={{ padding: "12px", width: "100%", marginBottom: "20px", borderRadius: "6px", border: "1px solid #ddd" }}
                />
                <button
                  onClick={handleSendOtp}
                  disabled={loading}
                  style={{ width: "100%", padding: "12px", background: "#024c8c", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
                >
                  {loading ? "Sending..." : "Send OTP"}
                </button>
              </>
            ) : (
              <>
                <input
                  type="text"
                  name="otp"
                  placeholder="Enter  OTP"
                  value={forgotData.otp}
                  onChange={handleForgotChange}
                  style={{ padding: "12px", width: "100%", marginBottom: "15px", borderRadius: "6px", border: "1px solid #ddd" }}
                />
                <input
                  type="password"
                  name="newPassword"
                  placeholder="Enter New Password"
                  value={forgotData.newPassword}
                  onChange={handleForgotChange}
                  style={{ padding: "12px", width: "100%", marginBottom: "20px", borderRadius: "6px", border: "1px solid #ddd" }}
                />
                <button
                  onClick={handleResetPassword}
                  disabled={loading}
                  style={{ width: "100%", padding: "12px", background: "#27ae60", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
                >
                  {loading ? "Processing..." : "Update Password"}
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;

